import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

class CollapseCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: (this.props.open !== undefined) ? this.props.open : true,
            title: (this.props.title !== undefined) ? this.props.title : ''
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.title !== this.props.title) {
            this.setState({
                title: this.props.title
            });
        }
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        }, () => {
            if (this.props.cb) this.props.cb(this.state.open)
        })
    }

    render() {
        return (
            <Card>
                <CardHeader onClick={() => this.showHide()}>
                    <Row className="align-items-center">
                        <Col xs="10" className="text-left">
                            {this.props.header === 'h4' ? <h4>{this.state.title}</h4> : <h3>{this.state.title}</h3>}
                        </Col>
                        <Col xs="2" className="text-right">
                            {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                        </Col>
                    </Row>
                </CardHeader>
                <Collapse isOpen={this.state.open}>
                    <CardBody>
                        {this.props.children}
                    </CardBody>
                </Collapse>
            </Card>
        )
    }
};

export default CollapseCard;